// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 424 ? "d50e61c5" : chunkId) + "." + {"402":"feac045e81a21ed8","424":"7becf1ac90bd99c1","695":"06a7a53347f80489"}[chunkId] + ".js";
};